import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import MicrosoftLoginDao from '../data/MicrosoftLoginDao';
// @ts-expect-error lib file not converted to TS
import LoginFailureHandlerFactory from '../lib/LoginFailureHandlerFactory';
const microsoftLoginDao = new MicrosoftLoginDao();
export const useMicrosoftLogin = () => {
  const {
    search
  } = useLocation();
  const history = useHistory(); // parse query params

  const [credentials, isMicrosoftLoginEnabled] = useMemo(() => {
    const qp = new URLSearchParams(search);
    const allParams = Object.fromEntries([...qp]);
    return [{
      loginPortalId: allParams.loginPortalId ? Number(allParams.loginPortalId) : undefined,
      loginRedirectUrl: allParams.loginRedirectUrl
    }, Boolean(allParams.microsoftLoginEnabled)];
  }, [search]);
  const loginWithMicrosoft = useCallback(() => {
    microsoftLoginDao.initialize(credentials).then(({
      redirectUrl
    }) => {
      window.location.href = redirectUrl;
    }).catch(LoginFailureHandlerFactory.createRavenReporter('Microsoft initialization failed', () => {}, // TODO - real trigger reset function
    history.push));
  }, [credentials, history]);
  return useMemo(() => ({
    loginWithMicrosoft,
    isMicrosoftLoginEnabled
  }), [loginWithMicrosoft, isMicrosoftLoginEnabled]);
};